/*
 * @Author: Hyman Choi
 * @Date: 2021-01-26 15:41:07
 * @LastEditTime: 2021-12-01 14:16:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\userDetail.js
 */
import request from "@/utils/request";
import config from "@/utils/config";
import qs from 'qs';
/**
 * 获取单个用户详情
 *
 * @param {*} params
 */
export function getOne(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminUsers/One",
		method: "get",
		params,
	});
}

/**
 * 修改单个用户信息
 *
 * @param {*} data
 */
export function updateUser(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminUsers/User",
		method: "patch",
		data,
	});
}

/**
 * 修改单个用户密码
 *
 * @param {*} params
 */
export function modifyUserPassword(params) {
	console.log(params)
	return request({
		url: config.API_MEDICAL1 + "/Api/V1/Users/User/Password", // /Api/V1/AdminUsers/ModifyPassword
		method: "post",
		headers: {'content-type': 'application/json;charset=UTF-8'},
		data: params
	});
}
export function getRegionList(data){
	return request({
		url: config.API_MEDICAL1 + "/Api/V1/Users/RegionList",
		method : "get",
		data,
	});
}

export function getUserService(){
	return [
		{
			id:0,
			name:"视频直播"
		},
		{
			id:1,
			name:"视频会议"
		},
		{
			id:2,
			name:"云存储"
		},
		{
			id:3,
			name:"会诊"
		},
		{
			id:4,
			name:"问答"
		},
	]
}

